import { render, staticRenderFns } from "./AuthPopups.vue?vue&type=template&id=6d1f77d3&"
import script from "./AuthPopups.vue?vue&type=script&lang=js&"
export * from "./AuthPopups.vue?vue&type=script&lang=js&"
import style0 from "./AuthPopups.vue?vue&type=style&index=0&id=6d1f77d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports